import React from 'react'

const LiveChatIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path d="M5.33301 11.333C5.33301 10.2284 4.43758 9.33299 3.33301 9.33299C2.22844 9.33299 1.33301 10.2284 1.33301 11.333V12.666C1.33301 13.7706 2.22844 14.666 3.33301 14.666C4.43758 14.666 5.33301 13.7706 5.33301 12.666V11.333Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.666 11.333C14.666 10.2284 13.7706 9.33299 12.666 9.33299C11.5614 9.33299 10.666 10.2284 10.666 11.333V12.666C10.666 13.7706 11.5614 14.666 12.666 14.666C13.7706 14.666 14.666 13.7706 14.666 12.666V11.333Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.33301 12V7.99999C1.33301 6.23179 2.03542 4.53602 3.28573 3.28571C4.53603 2.03541 6.23181 1.33299 8.00001 1.33299C9.76803 1.33326 11.4636 2.03579 12.7136 3.28607C13.9637 4.53634 14.666 6.23197 14.666 7.99999V12" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default LiveChatIcon
